<template>
  <div class="student-table">
    <div class="table-style">
      <el-table
        size="small"
        :data="tableData"
        :header-cell-style="{ background: '#f5f7fa' }"
      >
        <el-table-column
          width="150"
          align="center"
          prop="name"
          label="账号"
        ></el-table-column>

        <el-table-column
          width="100"
          align="center"
          prop="nickname"
          label="姓名"
        ></el-table-column>
        <el-table-column
          width="50"
          align="center"
          prop="sex"
          label="性别"
        ></el-table-column>

        <el-table-column
          width="150"
          align="center"
          prop="school_name"
          label="学校名称"
        ></el-table-column>
        <el-table-column
          width="150"
          align="center"
          prop="gradeStr"
          label="在校年级"
        ></el-table-column>

        <el-table-column align="center" label="所在班级" width="200">
          <template slot-scope="scope">
            <div v-for="item in scope.row.curriculum_class_list" :key="item.id">
              <span>{{ item.name }}</span> <br />
            </div>
          </template>
        </el-table-column>

        <el-table-column width="150" align="center" label="联系电话">
          <template slot-scope="scope">
            <span>{{ scope.row.parent_a }}</span>
            <span>{{ scope.row.parent_a_phone_num }}</span>
          </template>
        </el-table-column>

        <el-table-column width="150" align="center" label="家长微信">
          <template slot-scope="scope">
            <span>{{ scope.row.parent_b }}</span>
            <span>{{ scope.row.parent_b_phone_num }}</span>
          </template>
        </el-table-column>

        <el-table-column
          width="150"
          align="center"
          prop="leaderNickname"
          label="负责人"
        ></el-table-column>

        <el-table-column
          width="150"
          align="center"
          prop="created_time"
          label="录入时间"
        ></el-table-column>

        <el-table-column
          align="center"
          width="150"
          prop="name"
          label="操作"
          fixed="right"
        >
          <template slot-scope="scope">
            <el-button
              type="text"
              size="small"
              @click="handleDetails(scope.row, '4')"
              >转为正式</el-button
            >

            <el-button
              type="text"
              size="small"
              @click="updateStudent(scope.row)"
              >编辑</el-button
            >
            <el-button
              type="text"
              size="small"
              @click="deleteStudent(scope.row)"
              >删除</el-button
            >
          </template>
        </el-table-column>
      </el-table>
    </div>

    <!--转为正式学员--------------------------------------------->
    <el-dialog
      width="80%"
      title="转为正式学员"
      :visible.sync="dialogFormVisible1"
    >
      <el-form :model="form" size="small">
        <el-form-item label="学员姓名" :label-width="formLabelWidth">
          <span>{{ form.nickname }}</span>
        </el-form-item>

        <el-form-item label="选择班级" :label-width="formLabelWidth">
          <addStudentClassDialog
            ref="addStudentClassDialog"
            :student_user_id="form.student_user_id"
            @chooseAuditionClass="chooseAuditionClass"
          ></addStudentClassDialog>
        </el-form-item>

        <el-form-item
          v-show="haschoose_auditionclass"
          label="已选班级"
          :label-width="formLabelWidth"
        >
          <div style="background: #f7f8fa; padding: 10px">
            <span>班级名称</span>

            <span style="margin-left: 10px; font-weight: 500">{{
              chooseAuditionClassList.name
            }}</span>

            <el-button
              @click="deleteClass"
              style="margin-left: 40px"
              size="mini"
              type="danger"
              icon="el-icon-delete"
              circle
            ></el-button>

            <br />
            <span>体系名称</span>
            <span style="margin-left: 10px; font-weight: 500">{{
              chooseAuditionClassList.curriculum_name
            }}</span>

            <br />
            <span>上课老师</span>
            <span style="margin-left: 10px; font-weight: 500">{{
              chooseAuditionClassList.lecturer_nickname
            }}</span>
            <br />
            <span>授课时段</span>
            <span style="margin-left: 10px; font-weight: 500"
              >{{ chooseAuditionClassList.week_str }}/{{
                chooseAuditionClassList.time_str
              }}</span
            >
          </div>
        </el-form-item>

        <el-form-item label="选择班级" :label-width="formLabelWidth">
          <addformalClassDialog
            ref="addformalClassDialog"
            @chooseClass="chooseClass"
          ></addformalClassDialog>
        </el-form-item>

        <el-form-item
          v-show="haschoose_class"
          label="已选班级"
          :label-width="formLabelWidth"
        >
          <div style="background: #f7f8fa; padding: 10px">
            <span>班级名称</span>

            <span style="margin-left: 10px; font-weight: 500">{{
              form.chooseClassinfo.name
            }}</span>

            <el-button
              @click="deleteClass"
              style="margin-left: 40px"
              size="mini"
              type="danger"
              icon="el-icon-delete"
              circle
            ></el-button>

            <br />
            <span>体系名称</span>
            <span style="margin-left: 10px; font-weight: 500">{{
              form.chooseClassinfo.curriculum_name
            }}</span>

            <br />
            <span>上课老师</span>
            <span style="margin-left: 10px; font-weight: 500">{{
              form.chooseClassinfo.lecturer_nickname
            }}</span>
            <br />
            <span>授课时段</span>
            <span style="margin-left: 10px; font-weight: 500"
              >{{ form.chooseClassinfo.week_str }}/{{
                form.chooseClassinfo.time_str
              }}</span
            >
            <br />
            <span>课程价格(单位:元)</span>
            <span style="margin-left: 10px; font-weight: 500">{{
              form.chooseClassinfo.goods_price
            }}</span>
            <div style="width: 300px">
              <span>实收价格(单位:元)</span>
              <el-input
                size="small"
                placeholder="请输入实际交费金额"
                v-model="curriculum_class_price"
              ></el-input>
            </div>
          </div>
        </el-form-item>

        <el-form-item label="选择商品" :label-width="formLabelWidth">
          <addGoods ref="addGoods" @chooseGoodList="chooseGoodList"></addGoods>
        </el-form-item>

        <el-form-item
          v-show="haschoose_good"
          label="已选商品"
          :label-width="formLabelWidth"
        >
          <div style="background: #f7f8fa; padding: 10px">
            <div v-for="(item, index) of goodslist" :key="index">
              <span>商品名称</span>
              <span style="margin-left: 10px">{{ item.title }}</span>

              <el-button
                @click="deleteGoods(index)"
                style="margin-left: 40px"
                size="mini"
                type="danger"
                icon="el-icon-delete"
                circle
              ></el-button>

              <br />
              <span>商品原价(单位:元/个)</span>
              <span style="margin-left: 10px">{{ item.present_price }}</span>
              <div style="width: 300px">
                <span>商品现价(单位:元/个)</span>
                <el-input
                  v-model="item.price"
                  size="small"
                  placeholder="请输入实际交费金额"
                ></el-input>

                <span>采购数量</span>

                <el-input-number
                  style="margin-top: 10px; margin-left: 10px"
                  size="small"
                  v-model="item.sell_out_num"
                  @change="handleChange"
                  :min="1"
                  :max="10"
                  label="描述文字"
                >
                </el-input-number>
              </div>
              <el-divider></el-divider>
            </div>
          </div>
        </el-form-item>

        <el-form-item label="备注信息" :label-width="formLabelWidth">
          <el-input type="textarea" v-model="form.desc"></el-input>
        </el-form-item>
      </el-form>

      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible1 = false">取 消</el-button>
        <el-button type="primary" @click="Add_AuditionStudent">确 定</el-button>
      </div>
    </el-dialog>

    <el-dialog
      width="80%"
      title="订单确认"
      :visible.sync="outerVisible"
      append-to-body
    >
      <el-divider content-position="center">试听班级</el-divider>

      <div style="padding: 20px">
        <span>班级名称:</span>
        <span style="margin-left: 20px">
          {{ chooseAuditionClassList.name }}</span
        >
        <span style="margin-left: 20px">上课老师:</span>
        <span>{{ chooseAuditionClassList.lecturer_nickname }}</span>
        <span style="margin-left: 20px">授课时段:</span>
        <span
          >{{ chooseAuditionClassList.week_str }} /
          {{ chooseAuditionClassList.time_str }}</span
        >
      </div>

      <el-divider content-position="center">报名信息</el-divider>

      <div style="padding: 20px">
        <el-table
          size="small"
          :data="Audition_StudentData"
          style="width: 100%"
          :header-cell-style="{ background: '#f5f7fa' }"
        >
          <el-table-column
            align="center"
            prop="nickname"
            label="学员姓名"
          ></el-table-column>

          <el-table-column
            align="center"
            prop="subject_name"
            label="已选科目"
          ></el-table-column>

          <el-table-column
            align="center"
            prop="classname"
            label="报名班级"
          ></el-table-column>

          <el-table-column
            align="center"
            prop="lecturer_nickname"
            label="上课老师"
          ></el-table-column>

          <el-table-column align="center" label="授课时段" width="150">
            <template slot-scope="scope">
              {{ scope.row.week_str }} /
              {{ scope.row.time_str }}
            </template>
          </el-table-column>

          <el-table-column
            align="center"
            prop="start_date"
            label="开课日期"
          ></el-table-column>

          <el-table-column
            align="center"
            prop="end_date"
            label="结课日期"
          ></el-table-column>
        </el-table>
      </div>

      <el-divider content-position="center">订单信息</el-divider>

      <div style="padding: 20px">
        <el-table
          size="small"
          :data="Audition_GoodsData"
          style="width: 100%"
          :header-cell-style="{ background: '#f5f7fa' }"
        >
          <el-table-column
            align="center"
            prop="title"
            label="商品名称"
          ></el-table-column>

          <el-table-column
            align="center"
            prop="present_price"
            label="商品原价(元)"
          ></el-table-column>

          <el-table-column
            align="center"
            prop="price"
            label="商品现价(元)"
          ></el-table-column>

          <el-table-column
            align="center"
            prop="sell_out_num"
            label="购买数量(个)"
          ></el-table-column>

          <el-table-column align="center" label="合计(元)">
            <template slot-scope="scope">
              ¥{{
                parseFloat(scope.row.price) * parseFloat(scope.row.sell_out_num)
              }}
            </template>
          </el-table-column>
        </el-table>
      </div>

      <div style="float: right; margin-right: 20px">
        <span>订单总额: </span>
        <span style="color: #ea6d03; font-size: 20px; font-weight: 500"
          >¥ {{ total_price }}</span
        >
      </div>

      <div slot="footer" style="margin-top: 20px" class="dialog-footer">
        <el-button size="small" @click="Cancel_Order">取 消</el-button>
        <el-button size="small" type="primary" @click="Submit_Order"
          >提交订单</el-button
        >
      </div>
    </el-dialog>
  </div>
</template>

<script>
import addformalClassDialog from "@/components/addformalClassDialog";
import addStudentClassDialog from "@/components/addStudentClass";
import addGoods from "@/components/addGoods";



import {
addAuditionClassStudentToNormalClassForNormal
} from "@/api/educational.js";

export default {
  name: "open-student-table",
  components: { addformalClassDialog, addStudentClassDialog, addGoods },
  props: {
    tableData: {
      type: Array,
      defaule: () => [],
    },
  },
  data() {
    return {
      //意向学员转公开课试听学员
      form: {
        nickname: "",
        student_user_id: 0, //学生ID
        curriculum_class_id: "", //班级ID
        other_goods_list: [], //其他商品列表
        remark: "", //备注
        chooseClassinfo: {},
        chooseGoods: [],
      },
      formLabelWidth: "120px",
      dialogFormVisible1: false,

      curriculum_class_price: "", //班级商品实收价格
      haschoose_class: false, //是否选择了班级
      haschoose_auditionclass: false, //是否选择了之前试听的班级
      haschoose_good: false, //是否选择了商品
      chooseAuditionClassList: {},

      outerVisible: false,
      total_price: 0,
      Audition_StudentData: [],
      Audition_GoodsData: [],

      Goodslist: [],
      goodslist: [],
      //订单state
      order_state: "",
    };
  },
  methods: {
    detailStudent(row) {
      this.$router.push({
        name: "student-detail",
        query: {
          id: row.id,
        },
      });
    },
    updateStudent(row) {
      this.$router.push({
        name: "entering-student",
        query: {
          id: row.id,
        },
      });
    },
    deleteStudent(row) {
      console.log(row);
    },

    handleDetails(row, command) {
      if (command === "4") {
        console.log("试听学员转为正式学员");
        this.dialogFormVisible1 = true;
        this.form.nickname = row.nickname;
        this.form.chooseClassinfo = {};
        this.form.student_user_id = row.id;

        this.haschoose_class = false;
        this.order_state = "4"; //意向学员转公开课试听
        console.log(this.form.student_user_id);
      }
    },

    chooseClass(val) {
      console.log("子组件传值");
      console.log(val);
      this.form.chooseClassinfo = val;
      this.curriculum_class_price = val.goods_price;
      this.haschoose_class = true;
    },

    chooseAuditionClass(val) {
      console.log("子组件传值-转化前的试听班级");
      console.log(val);
      this.chooseAuditionClassList = val;
      this.haschoose_auditionclass = true;
    },

    //数组对象去重
    unique(arr) {
      const res = new Map();
      return arr.filter((arr) => !res.has(arr.id) && res.set(arr.id, 1));
    },

    chooseGoodList(val) {
      console.log("子组件传值-已选商品");
      console.log(val);
      for (var i = 0; i < val.length; i++) {
        this.Goodslist = [...new Set([...this.Goodslist, val[i]])];
      }
      //商品列表
      this.Goodslist = this.unique(this.Goodslist);
      this.Goodslist.forEach((item, index) => {
        console.log(index);
        const goods = {
          id: item.id,
          title: item.name,
          price: item.present_price,
          sell_out_num: 1,
        };
        //价格
        this.goodslist.push(goods);
      });

      this.goodslist = this.unique(this.goodslist);
      console.log("this.goodslist");
      console.log(this.goodslist);
      this.haschoose_good = true;
    },

    deleteClass() {
      this.form.chooseClassinfo = {};
      this.haschoose_class = false;
    },
    deleteGoods(index) {
      console.log("删除商品");
      console.log(index);
      //删除起始下标为1，长度为1的一个值(len设置1，如果为0，则数组不变)
      var goodlist = this.goodslist;
      goodlist.splice(index, 1);
      this.goodslist = goodlist;
      if (goodlist.length < 1) {
        this.haschoose_good = false;
        this.goodslist = [];
        this.Goodslist = [];
      }
    },

    Add_AuditionStudent() {
      console.log("添加试听学员");
      console.log(this.form);
      console.log(this.curriculum_class_price);
      console.log(this.goodslist);

      this.Audition_StudentData = [
        {
          nickname: this.form.nickname,
          classname: this.form.chooseClassinfo.name,
          week_str: this.form.chooseClassinfo.week_str,
          time_str: this.form.chooseClassinfo.time_str,
          subject_name: this.form.chooseClassinfo.subject_name,
          curriculum_name: this.form.chooseClassinfo.curriculum_name,
          lecturer_nickname: this.form.chooseClassinfo.lecturer_nickname,
          start_date: this.form.chooseClassinfo.start_date,
          end_date: this.form.chooseClassinfo.end_date,
        },
      ];

      this.Audition_GoodsData = [
        {
          title: this.form.chooseClassinfo.curriculum_name,
          present_price: this.form.chooseClassinfo.goods_price,
          price: this.curriculum_class_price,
          sell_out_num: "1",
        },
      ];

      for (var i = 0; i < this.goodslist.length; i++) {
        this.Audition_GoodsData = [
          ...new Set([...this.Audition_GoodsData, this.goodslist[i]]),
        ];
      }

      //计算总金额
      for (var j = 0; j < this.Audition_GoodsData.length; j++) {
        console.log("计算总金额");
        console.log(this.Audition_GoodsData);
        this.total_price =
          this.total_price +
          parseFloat(this.Audition_GoodsData[j].price) *
            parseFloat(this.Audition_GoodsData[j].sell_out_num);
      }

      console.log("总金额:" + this.total_price);
      this.outerVisible = true;
    },

Submit_Order() {
      console.log("提交订单");
      console.log("学生ID");
      console.log(this.form.student_user_id);
      console.log("班级ID");
      console.log(this.form.chooseClassinfo.id);
      console.log("班级商品价格");
      console.log(this.curriculum_class_price);
      console.log("其他商品列表");
      console.log(this.goodslist);

      console.log("试听班级ID");
      console.log(this.chooseAuditionClassList.id);

      if (this.order_state === "4") {
        console.log("试听学员转为正式学员");
        this.addAuditionClassStudentToNormalClassForNormal();
      }
    },

    //试听学员转为正式学员
    addAuditionClassStudentToNormalClassForNormal() {
      addAuditionClassStudentToNormalClassForNormal({
        student_user_id: this.form.student_user_id,
        curriculum_class_id: this.form.chooseClassinfo.id,
        curriculum_class_price: this.curriculum_class_price,
        other_goods_list: JSON.stringify(this.goodslist),
        audition_curriculum_class_id: this.chooseAuditionClassList.id,
      }).then((res) => {
        console.log("试听学员转为正式学员");
        console.log(res);
        if (res.is_create) {
          this.dialogFormVisible1 = false;
          this.outerVisible = false;
          this.$message.success("成功生成订单");
         // this.getNoClassStudentList();
          this.$router.push({ name: "listen-test-management" });
        }
      });
    },



    Cancel_Order() {
      console.log("取消订单");
      this.total_price = 0;
      this.outerVisible = false;
    },
  },
};
</script>

<style lang="scss" scoped>
.student-table {
  .reference {
    display: inline-block;
    width: 25px;
    height: 25px;
    margin-left: 10px;
    font-weight: bold;
    text-align: center;
    line-height: 25px;
    background-color: rgba(228, 213, 77, 0.5);
    border-radius: 50%;
  }
}
</style>